import { render, staticRenderFns } from "./r-item-state-menu.vue?vue&type=template&id=919241ce"
import script from "./r-item-state-menu.vue?vue&type=script&lang=js"
export * from "./r-item-state-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('919241ce')) {
      api.createRecord('919241ce', component.options)
    } else {
      api.reload('919241ce', component.options)
    }
    module.hot.accept("./r-item-state-menu.vue?vue&type=template&id=919241ce", function () {
      api.rerender('919241ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-state-menu.vue"
export default component.exports